import { Outlet } from "react-router";
import React from "react";
import { Box, Stack, styled, Typography } from "@mui/material";
import Logo from "../Reuse/UI/Logo";
import moment from "moment/moment";

const Container = styled(Stack)(({ theme }) => ({
  height: "calc(((1 - var(--template-frame-height, 0)) * 100dvh) - 0px)",
  minHeight: "100%",
  padding: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(4),
  },
  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    zIndex: -1,
    inset: 0,
    backgroundColor: "#f4f4f5",
    padding: {
      sm: 0,
    },
  },
}));

const External = ({ children }) => {
  return (
    <React.Fragment>
      <Container direction="column" justifyContent="space-between">
        <Box sx={{ position: "absolute" }}>
          <Logo text="Guardian Angel" />
        </Box>
        <Outlet />
        <Box
          sx={{
            position: "absolute",
            alignSelf: "center",
            bottom: 0,
          }}
        >
          <Typography variant="h6">Mithril Defense© {moment().format("YYYY")}</Typography>
        </Box>
      </Container>
    </React.Fragment>
  );
};

export default External;
